module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-3rd@2x-a0baab2b389234f7c0b4a31050da2b8e.png";